<template>
  <div>
    <div class="mb-u6 text__title">Your email has been verified</div>
    <div class="mb-u6 text__description">
      Your email address, <span class="text-primary">{{ email }}</span
      >, has been verified.
    </div>
    <b-button variant="primary" @click="goToOnBoardingPage()"> Go to 4lifelonglearning </b-button>
  </div>
</template>

<script>
import { optimizelyMixin } from '@/mixins/optimizelyMixin';
export default {
  mixins: [optimizelyMixin],
  props: {
    email: {
      type: String,
      required: true
    }
  },

  methods: {
    async goToOnBoardingPage() {
      if (this.$_isFeatureEnabled('onboarding')) {
        this.$router.push({ name: 'on-boarding' });
      } else {
        this.$router.push({ name: 'learning-unit' });
      }
    }
  }
};
</script>

<style scoped>
.text__title {
  font-weight: 700;
  font-size: 26.6px;
  line-height: 32px;
  color: #3b3e66;
}

.text__description {
  font-weight: 400;
  font-size: 15.2px;
  line-height: 22px;
  color: #3b3e66;
}
</style>
